import { ProjectContentItemDc } from "@evergis/api";
import { TreeData } from "@atlaskit/tree";

import { combineLayers } from "../hooks/project/useProjectLayers";

export const LAYER_TREE_ROOT_ID = "layers-root";

export const getLayerChildren = (children?: ProjectContentItemDc[]): string[] | null =>
  children?.map(({ name }) => name) || null;

export const convertLayersToTree = (
  layers: ProjectContentItemDc[],
  groupsExpanded?: Record<string, boolean>,
): TreeData["items"] => {
  return layers.reduce(
    (result, layer) => ({
      ...result,
      [layer.name]: {
        id: layer.name,
        children: getLayerChildren(layer.children),
        hasChildren: !!layer.children?.length,
        isExpanded: groupsExpanded?.[layer.name] || layer.isExpanded,
        data: layer,
      },
      ...(layer.children?.length ? convertLayersToTree(layer.children, groupsExpanded) : {}),
    }),
    {},
  );
};

export const generateTree = (
  layers: ProjectContentItemDc[],
  groupsExpanded?: Record<string, boolean>,
  searchFilter = "",
): TreeData => {
  const currentLayers = searchFilter ? combineLayers(layers, { onlyVisible: false }) : layers;

  return {
    rootId: LAYER_TREE_ROOT_ID,
    items: {
      [LAYER_TREE_ROOT_ID]: {
        id: LAYER_TREE_ROOT_ID,
        children: getLayerChildren(currentLayers),
        hasChildren: true,
        isExpanded: true,
      },
      ...(layers?.length ? convertLayersToTree(currentLayers, groupsExpanded) : {}),
    },
  };
};

export const checkLayerVisibility = (layer?: { isVisible?: boolean }) =>
  layer?.isVisible === undefined || layer?.isVisible;
